const strings = {
  heading: 'Approved Domains',
  addLabel: 'Add domain',
  addPlaceholder: 'example.com',
  addButton: 'Add',
  removeButton: 'Remove',
  emptyState: 'No approved domains yet.',
  errorLoad: 'Failed to load domains.',
  errorAdd: 'Failed to add domain.',
  errorRemove: 'Failed to remove domain.',
  errorDuplicate: 'That domain is already approved.',
};

export default strings;
